import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsvExportComponent } from './csv-export/csv-export.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [CsvExportComponent],
    imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
    exports: [CsvExportComponent],
})
export class CsvExportModule {}
